import { ViewColumnOutlined as ViewColumnOutlinedIcon } from '@mui/icons-material';
import type { DataGridProProps, GridValidRowModel } from '@mui/x-data-grid-pro';
import type { ReactElement } from 'react';

import { StyledDataGrid } from '../../styled-data-grid-pro';

type GeneralDataGridProps<T extends GridValidRowModel> = DataGridProProps<T>;

export const GeneralDataGrid = <T extends GridValidRowModel>({
    onPaginationModelChange,
    paginationModel,
    ...props
    // biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration
}: GeneralDataGridProps<T>): ReactElement<any> | null => {
    return (
        <StyledDataGrid
            {...props}
            localeText={{
                ...props.localeText,
                toolbarColumns: (
                    <ViewColumnOutlinedIcon fontSize="small" sx={{ '&:hover': { backgroundColor: 'transparent' } }} />
                ),
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={onPaginationModelChange}
        />
    );
};
